import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { MemoOrigin, UUID } from "@/lib/types";

/** The Protokoll section a to-do came from, or null. Fetches only when `rowId`
 * is set (the caller gates on eligibility first — see `memoOriginEligible`), so
 * a non-Aufgaben board / sub-task never hits the endpoint. Batched endpoint,
 * called with one id here; Home can reuse `api.memoOrigins` for many. */
export function useMemoOrigin(rowId: UUID | undefined): MemoOrigin | null {
  const q = useQuery({
    enabled: Boolean(rowId),
    queryKey: rowId ? queryKeys.memoOrigin(rowId) : ["rows", "void", "memo-origin"],
    queryFn: async () => {
      const res = await api.memoOrigins([rowId as UUID]);
      return res.origins[rowId as UUID] ?? null;
    },
    staleTime: 5 * 60 * 1000,
  });
  return q.data ?? null;
}
